import DeliveryConfigListener from './delivery-config-listener';

export default DeliveryConfigListener;
